import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchSystemUsage = async () => {
  const response = await fetch(`${API_BASE_URL}/system/usage`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchAcademicYears = async (activeOnly = false) => {
  const url = activeOnly ? `${API_BASE_URL}/academic-years?active_only=true` : `${API_BASE_URL}/academic-years`;
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};


export const fetchDashboardCard = async (tableName) => {
  const response = await fetch(`${API_BASE_URL}/dashboard/card?tableName=${tableName}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchAllSessions = async () => {
  const response = await fetch(`${API_BASE_URL}/all-sessions`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchDashboardFilterOptions = async () => {
  const response = await fetch(`${API_BASE_URL}/dashboard/filter-options`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchDashboardAnalytics = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  if (filters.academic_year_id) queryParams.append('academic_year_id', filters.academic_year_id);
  if (filters.institution_id) queryParams.append('institution_id', filters.institution_id);
  if (filters.instructor_id) queryParams.append('instructor_id', filters.instructor_id);
  if (filters.menu_key) queryParams.append('menu_key', filters.menu_key);

  const response = await fetch(`${API_BASE_URL}/dashboard/analytics?${queryParams.toString()}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};


export const fetchUserWatchAnalytics = async () => {
  const response = await fetch(`${API_BASE_URL}/video-watch-track/user`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};
